// =============================================================================
// staticSite/menuScope — minimalny model (kategorie, strony, autor) do
// walidacji/renderu menu BEZ assembleSite: ze snapshotu ostatniej analizy
// (static_site_pages). Uzywane przez MenuCard (lista „Dostepne") i StudioPreview
// (podmiana nav bez builda). Liczby wpisow per kategoria nie sa w snapshocie
// (count = 1) — prawdziwe daje assembleSite pod „Odswiez liste".
// =============================================================================

import type { SiteModel, StaticSiteRow } from "./types";
import type { SitePageSnapshot } from "./migrationRunner";

/** Minimalny model do walidacji/budowy menu — ze snapshotu analizy albo z assembleSite. */
export type MenuScope = Pick<SiteModel, "categories" | "pages" | "author" | "domain">;

export function scopeFromSnapshot(site: StaticSiteRow, rows: SitePageSnapshot[]): MenuScope | null {
  if (!rows.length) return null;
  const base = (site.settings?.category_base ?? "category").replace(/^\/+|\/+$/g, "");
  const catPrefix = base ? `/${base}/` : "/";
  const posts = rows.filter((r) => r.kind === "article" || r.kind === "pillar" || r.kind === "legacy_post");
  const catRows = rows.filter((r) => r.kind === "category");
  // Kategorie: snapshot ma wiersz kind=category per kategoria (path /category/slug/); liczba wpisow z last_parity nie jest
  // znana per kategoria — liczymy z tytulow? Nie: liczymy z PageParity (brak categorySlug). Dlatego count = 1 (min) +
  // przy „Odswiez liste" assembleSite daje prawdziwe liczby.
  const categories = catRows.map((r) => {
    const slug = r.url_path.startsWith(catPrefix) ? r.url_path.slice(catPrefix.length).replace(/\/$/, "") : r.url_path.replace(/^\/|\/$/g, "");
    return { slug, name: r.title || slug, path: r.url_path, description: null, count: Math.max(1, posts.length ? 1 : 0) };
  });
  const pages = rows.filter((r) => r.kind !== "category").map((r) => ({
    kind: r.kind as SiteModel["pages"][number]["kind"], id: r.url_path, sourceTable: null, sourceId: null, path: r.url_path, sourceUrl: null,
    title: r.title || r.url_path, seoTitle: null, metaDescription: null, bodyHtml: "", excerpt: null, featuredImageUrl: null,
    datePublished: null, dateModified: null, categorySlug: null, categoryName: null, schemaGraph: null, schemaWarnings: [], schemaErrors: [],
  }));
  const authorRow = rows.find((r) => r.kind === "author");
  return {
    categories, pages, domain: site.domain,
    author: authorRow ? { name: authorRow.title || "Autor", slug: "autor", path: authorRow.url_path, photoUrl: null, bioHtml: null, jobTitle: null, sameAs: [] } : null,
  };
}
